import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Hero} from '../models';

@Injectable()
export class HeroService extends IoService {
  protected model = Hero;
  protected listUrl = '/hero/';
}
